import React, { useCallback, useContext } from 'react'
import PageBanner from 'components/Luxkit/Banners/PageBanner'
import ModalContext from 'contexts/ModalContext'
import QueenslandCycloneWarningModal from '../HeaderModals/QueenslandCycloneWarningModal'
import LineExclamationTriangleIcon from 'components/Luxkit/Icons/line/LineExclamationTriangleIcon'

import { useAppSelector } from 'hooks/reduxHooks'

import { isCustomerAffectedByQueenslandCyclone } from 'selectors/orderSelectors'

function QueenslandCycloneWarningNotificationBanner() {
  const showModal = useContext(ModalContext)

  const handleOpenQueenslandCycloneWarningModal = useCallback(() => {
    showModal(<QueenslandCycloneWarningModal/>)
  }, [showModal])

  const showQueenslandCycloneWarningBanner = useAppSelector(isCustomerAffectedByQueenslandCyclone)

  if (!showQueenslandCycloneWarningBanner) {
    return null
  }

  return <PageBanner
    kind="warning"
    align="center"
    icon={<LineExclamationTriangleIcon />}
    description={<>
      <strong>Important:</strong> Tropical Cyclone Alfred, may impact bookings.{' '}
      Click here if your travel plans are affected.
    </>}
    secondaryActionButtonProps={{
      children: 'More info',
      onClick: handleOpenQueenslandCycloneWarningModal,
    }}
  >
  </PageBanner>
}

export default QueenslandCycloneWarningNotificationBanner
